var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2787_10729)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2787_10729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3276 3.05C16.4938 3.04802 18.6118 3.68855 20.4139 4.89054C22.2159 6.09254 23.6209 7.80201 24.4513 9.80268C25.2816 11.8034 25.4998 14.0054 25.0785 16.1301C24.6571 18.2549 23.615 20.2069 22.084 21.7393C20.553 23.2717 18.6019 24.3155 16.4776 24.7389C14.3532 25.1622 12.151 24.9459 10.1496 24.1174C8.14814 23.2889 6.43739 21.8855 5.23375 20.0845C4.0301 18.2836 3.38764 16.1661 3.38764 14C3.40077 11.1017 4.55728 8.32561 6.6058 6.27522C8.65433 4.22482 11.4293 3.06578 14.3276 3.05ZM14.3276 1C11.7565 1 9.24307 1.76244 7.10523 3.1909C4.96739 4.61935 3.30115 6.64968 2.31721 9.02512C1.33327 11.4006 1.07583 14.0144 1.57743 16.5362C2.07904 19.0579 3.31717 21.3743 5.13525 23.1924C6.95334 25.0105 9.26972 26.2486 11.7915 26.7502C14.3132 27.2518 16.9271 26.9944 19.3025 26.0104C21.678 25.0265 23.7083 23.3603 25.1367 21.2224C26.5652 19.0846 27.3276 16.5712 27.3276 14C27.3276 10.5522 25.958 7.24558 23.52 4.80761C21.0821 2.36964 17.7755 1 14.3276 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0005 31.2901L25.6304 23.8701L24.2104 25.2801L31.5805 32.7001C31.673 32.7934 31.7831 32.8674 31.9043 32.9182C32.0255 32.9689 32.1555 32.9952 32.2869 32.9957C32.4183 32.9961 32.5485 32.9707 32.6701 32.9209C32.7916 32.871 32.9022 32.7977 32.9954 32.7051C33.0887 32.6125 33.1628 32.5025 33.2135 32.3813C33.2642 32.2601 33.2905 32.13 33.291 31.9987C33.2915 31.8673 33.2661 31.7371 33.2162 31.6155C33.1663 31.4939 33.093 31.3834 33.0005 31.2901Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2787_10729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(-0.000488281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2787_10729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(-2.00049 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.42bbaf529bcc79bc35983ee83f19622f.svg";
export { ForwardRef as ReactComponent };